import { gql } from '@apollo/client'

export const getActiveLeaseQuery = gql`
  query GetActiveLease($personId: String!) {
    activeLease(personId: $personId) {
      lease_id
      lease_duration
      lease_name
      move_in_date
      move_out_date
      move_out_expected_date
      disable_online_payments
      lease_term {
        month_to_month
        lease_term_id
        lease_term_end
        month_to_month
        lease_term_start
        lease_term_duration
      }
    }
  }
`

export const getLeaseQuery = gql`
  query GetLease($personId: String!) {
    lease(personId: $personId) {
      lease_id
      lease_duration
      lease_name
      move_in_date
      move_out_date
      move_out_expected_date
      disable_online_payments
      lease_term {
        month_to_month
        lease_term_id
        lease_term_end
        month_to_month
        lease_term_start
        lease_term_duration
      }
    }
  }
`

export const getLeaseCashLedgerQuery = gql`
  query GetLeaseCashLedger($leaseId: String!) {
    leaseCashLedger(leaseId: $leaseId) {
      lease_id
      transactions {
        date {
          value
        }
        transaction_type
        payee_payer
        description
        charge
        receipt
        amount
      }
    }
  }
`

export const getLeaseOccupantsQuery = gql`
  query GetLeaseOccupants($leaseId: String!) {
    leaseOccupants(leaseId: $leaseId) {
      occupants {
        person_id
        person {
          first_name
          last_name
        }
      }
    }
  }
`

export const getAnimalPersonMapsQuery = gql`
  query GetAnimalPersonMaps($personIds: [String!]!) {
    animalPersonMaps(personIds: $personIds) {
      animals {
        animal_person_map_id
        animal_id
        animal {
          animal_name
        }
      }
    }
  }
`

export const getLeaseBalanceQuery = gql`
  query GetLeaseBalance($leaseId: String!) {
    leaseBalance(leaseId: $leaseId) {
      amount
    }
  }
`

export const getPrepaymentQuery = gql`
  query GetPrepayment($leaseId: String!) {
    prepayment(leaseId: $leaseId) {
      lease_id
      tenants
      building_id
      address_line_1
      address_line_2
      building_name
      prepayment_amount
      charge_amount
      credit_amount
    }
  }
`

export const getActiveLeaseSettingByLeaseIdQuery = gql`
  query GetActiveLeaseSettingByLeaseId($leaseId: String!) {
    activeLeaseSettingByLeaseId(leaseId: $leaseId) {
      lease_setting_id
      lease_id
      lease_term_id
      late_fee_type_id
      late_fee_amount
      late_fee_charge_day
      active
    }
  }
`
